module.exports = "/static/assets/681994a7b229e8390f9ae5e94312ea1a.png";